import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRight, Wrench, Building2, Droplets, Thermometer, Settings } from 'lucide-react';
import { scrollToSection } from '../utils/scrollToSection';
import '../styles/services.css';

const Services = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  const services = [
    {
      id: 1,
      title: 'Reformas Integrales',
      description: 'Transformamos espacios completos con diseño personalizado. Cocinas, baños, salones y viviendas completas.',
      image: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_icb-preview/artifacts/0a63t7i5_imagen%20reformas%20integrales.png',
      icon: Wrench,
    },
    {
      id: 2,
      title: 'Construcción en General',
      description: 'Obra nueva, ampliaciones, piscinas, cerramientos y terrazas. Proyectos desde la planificación hasta la finalización.',
      image: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_icb-preview/artifacts/fir6j94n_Captura%20de%20pantalla%202026-07-24%20133541.png',
      icon: Building2,
    },
    {
      id: 3,
      title: 'Tratamientos de Agua',
      description: 'Sistemas de ósmosis inversa, descalcificadores y mantenimiento de filtros. Solución específica para el agua dura de la Costa Blanca.',
      image: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_icb-preview/artifacts/ej2frajy_imagen%20tratamiento%20de%20aguas.png',
      icon: Droplets,
    },
    {
      id: 4,
      title: 'Climatización y Aerotermia',
      description: 'Instalación y mantenimiento de aerotermia, aire acondicionado, refrigeración y calefacción para hogares, locales comerciales y naves industriales.',
      image: 'https://images.unsplash.com/photo-1762341123870-d706f257a12e?auto=format&fit=crop&w=700&q=80',
      icon: Thermometer,
    },
    {
      id: 5,
      title: 'Mantenimiento Integral',
      description: 'Electricidad, fontanería, carpintería, cerrajería y todos los oficios. Mantenimiento preventivo y correctivo completo.',
      image: 'https://images.unsplash.com/photo-1731694411560-050e5b91e943?auto=format&fit=crop&w=700&q=80',
      icon: Settings,
    },
  ];

  const scrollToContact = () => scrollToSection('contacto');

  return (
    <section id="servicios" className="services" ref={sectionRef}>
      <div className="services-container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6 }}
        >
          <span className="section-label">NUESTROS SERVICIOS</span>
          <h2 className="section-title">Soluciones Integrales para Tu Proyecto</h2>
        </motion.div>

        <div className="services-grid">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.id}
                className="service-card"
                initial={{ opacity: 0, y: 50 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ y: -8 }}
              >
                <div className="service-image-wrapper">
                  <img src={service.image} alt={service.title} className="service-image" loading="lazy" />
                  <div className="service-image-overlay"></div>
                </div>
                <div className="service-content">
                  <div className="service-icon">
                    <Icon size={24} strokeWidth={1.5} />
                  </div>
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  <button className="service-link" onClick={scrollToContact}>
                    Solicitar Presupuesto
                    <ArrowRight size={16} className="service-arrow" />
                  </button>
                </div>
                <div className="service-accent-line"></div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;